/**
 * SiteContext — SPA architectural convergence plan §6.3.
 *
 * The convergence target has SiteContext own the AUTHORIZED API list
 * and the active site. Assignment removal aborts streams, clears
 * site caches, and reconciles selection (plan §6.3: "SiteContext
 * owns the authorized API list and active site; assignment removal
 * aborts streams, clears site caches, and reconciles selection.").
 *
 * The runtime config no longer ships a static site list as a
 * security-relevant input (plan §6.4: "Keep runtime config limited
 * to edge/API bootstrap and OIDC values; remove static
 * security-authoritative sites, wsBaseUrl, seed registries/catalogs,
 * and loose site filters."). Sites come exclusively from
 * `nexsoss-api-server`'s `/api/v1/sites` endpoint, gated by the
 * caller's ZITADEL JWT.
 */
import { createContext } from 'react';
import type { SiteId, SiteSummary } from '../api/v1';

export interface ActiveSite {
  /** The site id, opaque; matches the deployment-manifest site id. */
  id: SiteId;
  label: string;
}

export interface SiteContextValue {
  /** The sites assigned to the current caller, sourced from the API. */
  sites: ReadonlyArray<SiteSummary>;
  /** The currently selected site, or null if none assigned. */
  site: ActiveSite | null;
  /** Set the active site (no-op if `siteId` is not in `sites`). */
  setSite: (siteId: SiteId) => void;
  /** Force a reconciliation (called on assignment-removal events). */
  reconcile: () => void;
}

export const SiteContext = createContext<SiteContextValue | null>(null);